import { createContext } from 'react';

const ToolbarEditContext = createContext();

export default ToolbarEditContext;
